var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.833 18.333h-2.5a1.667 1.667 0 0 1-1.666-1.666v-5.834a1.667 1.667 0 0 1 1.666-1.666h2.5M11.667 7.5V4.167a2.5 2.5 0 0 0-2.5-2.5l-3.334 7.5v9.166h9.4a1.667 1.667 0 0 0 1.667-1.416l1.15-7.5A1.669 1.669 0 0 0 16.383 7.5h-4.716Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLike;